// extracted by mini-css-extract-plugin
export default {"rdblock":"PP","container":"QP","rddesc":"RP","title":"SP","copy":"TP","image":"UP","tipview":"VP","rdtip":"WP"};
    if(module.hot) {
      // 1721922365247
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  